var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplePackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.43,49.32l-29.41-16.98c-3.1-1.79-6.95-1.79-10.05,0l-11.54,6.66h-.02s-.02,.02-.02,.02l-17.83,10.3c-3.1,1.79-5.02,5.12-5.02,8.7v33.96c0,3.58,1.93,6.91,5.02,8.7l29.41,16.98c1.55,.89,3.29,1.34,5.02,1.34s3.47-.45,5.02-1.34l29.41-16.98c3.1-1.79,5.02-5.12,5.02-8.7V58.02c0-3.58-1.92-6.91-5.02-8.7Zm-37.05-12.82c.81-.47,1.72-.7,2.62-.7s1.81,.23,2.62,.7l29.41,16.98s.08,.05,.12,.08l-12.38,7.52-31.65-19.23,9.26-5.35Zm4.04,35.72c-.15-.1-.29-.21-.45-.3l-32.47-18.75,14.87-8.59,31.77,19.3-13.72,8.33Zm-34.82-17.58l-.93,1.61c.21-.59,.53-1.13,.93-1.61Zm1.37,41.88c-1.62-.93-2.62-2.67-2.62-4.54V58.02c0-.36,.05-.71,.12-1.06l33.1,19.11c.43,.25,.7,.71,.7,1.21v36.86c-.66-.09-1.3-.31-1.89-.65l-29.41-16.98Zm66.68-4.54c0,1.87-1,3.61-2.62,4.54l-27.96,16.14v-35.38c0-.34-.04-.67-.09-1l30.65-18.61c0,.12,.02,.23,.02,.35v33.96Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplePackage);
export default __webpack_public_path__ + "static/media/simple-package.4c8011daf274436a1f42133913f0f744.svg";
export { ForwardRef as ReactComponent };